module.exports = __webpack_public_path__ + "img/cta-section-bg.f73fb73f.png";